<template>
    <div class="ServicePlatform-page" @scroll="bingsrcoll">
        <div class="visible-sm-and-down">
            <div class="mobile-banner">
                <img src="../assets/mobile/serviceplatform01_img.jpg" alt="服务平台">
            </div>
            <div class="servicsplat-tabpart">
                <div class="servicsplat-tab" v-for="item in custormAnchor_list" :key="item.dictValue"
                    @click="platformType = item.dictValue"
                    :class="{ 'servicsplat-tabActive': platformType == item.dictValue }">{{ item.dictLabel }}</div>
            </div>
            <div class="mobile-content">
                <div class="servicsplat-listMain">
                    <div class="servicsplat-list" v-for="(item, index) in soft_custormAnchor_content" :key="index"
                        v-show="platformType == item.softType">
                        <div class="servicsplat-list-title">{{ item.softName }}</div>
                        <div class="servicsplat-list-desc">{{ item.softContent }}</div>
                        <div class="servicsplat-list-img">
                            <img :src="item.picUrl" :alt="item.softName">
                        </div>
                    </div>
                </div>
            </div>
            <home-foot></home-foot>
        </div>

        <div class="hidden-sm-and-down" style="height:calc(100% - 60px);">
            <!-- <div > -->
            <div class="first-page" ref="bannerDom">
                <img v-if="cooperativeCustomersData.children[0].requestType.indexOf('image') > -1"
                    :src="cooperativeCustomersData.children[0].requestPath" :alt="cooperativeCustomersData.dictLabel"
                    style="width:100%;height:100%">
                <div v-else style="width: 100%;height:100%;">
                    <video class="header-video" id="aboutvideo" width="100%" height="100%" name="media" muted loop>
                        <source :src="cooperativeCustomersData.children[0].requestPath" type="video/mp4">
                        您的浏览器不支持 video 标签。
                    </video>
                </div>
                <div class="first-page-title">
                    <div>{{ cooperativeCustomersData.children[0].title }}</div>
                    <div></div>
                    <div v-if="videoAll && videoAll[0] && videoAll[0].title == '观看全部视频'" @click="openVideoShow"
                        style="text-align: left;font-size: 22px;cursor: pointer;">
                        <i class="el-icon-video-play"
                            style="font-weight: inherit;font-size: 30px;vertical-align: text-top;margin-right: 2px;"></i>
                        观看全部视频
                    </div>
                    <pre v-else class="first-page-titledesc">{{ cooperativeCustomersData.children[0].content }}</pre>

                    <div v-if="isEn == '0'" class="more-btn" @click="goMerchart" @mouseenter="btnEnter" @mouseleave="btnOut">
                        <div class="btn-bgm" ref="btnBgmDom"></div>
                        <div class="btn-text" ref="moreBtnDom" style="line-height:42px;">进入德卡云服务</div>
                    </div>
                    <div v-if="isEn == '0'" class="more-btn" @click="goMerchartOpen" @mouseenter="btnEnterOpen" @mouseleave="btnOutOpen" >
                        <div class="btn-bgm" ref="btnBgmDomOpen"></div>
                        <div class="btn-text" ref="moreBtnDomOpen" style="line-height:42px;">进入开放平台</div>
                    </div>
                </div>
            </div>

            <div v-if="isEn == '0'" :class="['about-menu', window_height < (scroll_Value + 10) ? 'fix-menu' : '']">
                <div v-for="item in custormAnchor_list" :key="item.dictValue"
                    @click.prevent="custormAnchor('miao' + item.dictValue, item.dictValue)"
                    :href="'#miao' + item.dictValue">
                    <span :class="[custormAnchor_nav == ('miao' + item.dictValue) ? 'menu-active' : '']">{{
                            item.dictLabel
                    }}</span>
                </div>
            </div>
            <div v-if="isEn == '0'" :class="['about-content', 'row', 'show-mao']">
                <!-- ,custormAnchor_nav=='miao1'?'show-mao':'hide-mao' -->
                <div :class="['row', 'col-md-90']" :id="custormAnchor_nav"
                    v-for="(item, index) in soft_custormAnchor_content"
                    v-show="custormAnchor_nav == 'miao' + item.softType" :key="index" style="margin:60px auto;">
                    <div class="col-md-6" v-if="index % 2 == 0">
                        <div class="about-content-img about-content-img-left">
                            <img :src="item.picUrl" :alt="item.softName" style="height:320px">
                        </div>
                    </div>
                    <div class="col-md-6 about-content-text about-content-text-right" v-if="index % 2 == 0">
                        <div class="about-content-title">
                            {{ item.softName }}
                        </div>
                        <div class="about-content-describe">
                            {{ item.softContent }}
                        </div>
                        <div class="about-content-line"></div>
                    </div>
                    <div class="col-md-6 about-content-text about-content-text-left" v-if="index % 2 != 0">
                        <div class="about-content-title">
                            {{ item.softName }}
                        </div>
                        <div class="about-content-describe">
                            {{ item.softContent }}
                        </div>
                        <div class="about-content-line"></div>
                    </div>
                    <div class="col-md-6" v-if="index % 2 != 0">
                        <div class="about-content-img about-content-img-right">
                            <img :src="item.picUrl" :alt="item.softName" style="height:320px">
                        </div>
                    </div>
                </div>

            </div>
            <videoCommon ref="videoProp" v-if="videoAll[0]" :videoTitle="videoAll[0].title"
                :videoUrl="videoAll[0].requestPath"></videoCommon>
            <home-foot></home-foot>
        </div>

    </div>
</template>


<script>
import HomeFoot from "@/components/HomeFoot"
import videoCommon from "@/components/videoCommon";
import Bus from '../Bus.js';
export default {
    name: "ServicePlatform",
    components: {
        HomeFoot,
        videoCommon
    },
    data() {
        return {
            time: null,
            timeOpen: null,
            btnWidth: 0,
            btnWidthOpen: 0,
            window_height: 900, //$(".first-page").height(),
            scroll_Value: "0",
            custormAnchor_nav: "miao1",
            custormAnchor_list: "",
            custormAnchor_content: "",
            window_width: document.body.clientWidth < 991 ? true : false,
            platformType: 1,
            videoAll: "",
            softType: "1",
            loading_change: false,
            decard_cloud_url: "",
            open_login_url: "",
            cooperativeCustomersData:{}, //合作客户
            isEn:'0',
        };
    },
    created() {
        this.$picData.map((item) => {
            if (item.dictCode == 107) {
                this.cooperativeCustomersData = item
            }

        })
        setTimeout(
            function () {
                this.window_height = $(".first-page").height();
                // console.log(this.window_height)
            }, 1000)
        this.isEn = ('1' ==sessionStorage.getItem("isEn")? sessionStorage.getItem("isEn") : '0');
    },
    mounted() {
        let dictType = '';
        if (this.isEn == '1'){
          dictType = 'website_soft_type_en';
        }else{
          dictType = 'website_soft_type';
        }
        axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/dict/data/type/`+dictType
        ).then((response) => {
            var res = response.data
            if (res.code == 200) {
                this.custormAnchor_list = res.data;
            }
        }).catch(res => {

        })
        axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/config/configKey/tmbs_login_url`,).then(response => {
            var res = response.data
            if (res.code === 200) {
                this.decard_cloud_url = res.data;
            } else {
                this.$message.error(res.msg ? res.msg : '请求有误，请稍后重试')
            }
        })
        axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/config/configKey/open_login_url`,).then(response => {
            var res = response.data
            if (res.code === 200) {
                this.open_login_url = res.data;
            } else {
                this.$message.error(res.msg ? res.msg : '请求有误，请稍后重试')
            }
        })

        this.getAllWebsiteSoftware();

        this.videoAll = this.cooperativeCustomersData.children.filter(t => t.title == "观看全部视频");
    },
    methods: {
        goMerchart() {
            window.open(this.decard_cloud_url);
        },
        goMerchartOpen() {
            window.open(this.open_login_url);
        },
        bingsrcoll(e) {
            this.scroll_Value = e.srcElement.scrollTop;
        },
        custormAnchor(v, value) {
            this.custormAnchor_nav = v;
            this.softType = value;
        },
        //按钮鼠标移入
        btnEnter() {
            clearInterval(this.time)
            this.$refs.moreBtnDom.style.color = "rgb(0 0 0)"
            var that = this;
            that.time = setInterval(() => {
                that.btnWidth += 1.8;
                that.$refs.btnBgmDom.style.width = that.btnWidth + "px"
                if (that.btnWidth >= 160) {
                    that.$refs.btnBgmDom.style.width = "160px"
                    clearInterval(that.time)
                }
            }, 1)
        },
        //按钮鼠标移出
        btnOut() {
            clearInterval(this.time)
            this.$refs.moreBtnDom.style.color = "rgb(255,255,255)"
            this.time = setInterval(() => {
                this.btnWidth -= 1.8
                this.$refs.btnBgmDom.style.width = this.btnWidth + "px"
                if (this.btnWidth <= 0) {
                    this.$refs.btnBgmDom.style.width = "0"
                    clearInterval(this.time)
                }
            }, 1)
        },
        //开放平台按钮鼠标移入
        btnEnterOpen() {
            clearInterval(this.timeOpen)
            this.$refs.moreBtnDomOpen.style.color = "rgb(0 0 0)"
            var that = this;
            that.timeOpen = setInterval(() => {
                that.btnWidthOpen += 1.8;
                that.$refs.btnBgmDomOpen.style.width = that.btnWidthOpen + "px"
                if (that.btnWidthOpen >= 160) {
                    that.$refs.btnBgmDomOpen.style.width = "160px"
                    clearInterval(that.timeOpen)
                }
            }, 1)
        },
        //开放平台按钮鼠标移出
        btnOutOpen() {
            clearInterval(this.timeOpen)
            this.$refs.moreBtnDomOpen.style.color = "rgb(255,255,255)"
            this.timeOpen = setInterval(() => {
                this.btnWidthOpen -= 1.8
                this.$refs.btnBgmDomOpen.style.width = this.btnWidthOpen + "px"
                if (this.btnWidthOpen <= 0) {
                    this.$refs.btnBgmDomOpen.style.width = "0"
                    clearInterval(this.timeOpen)
                }
            }, 1)
        },
        change_window_height() {
            this.window_height = $(".first-page").height();
        },
        openVideoShow() {
            this.$refs.videoProp.openVideoShow();
        },
        getAllWebsiteSoftware() {
            axios.get(`${window.$server_config.VUE_APP_WEBSITE_API}outer/software/list`, { params: { softType: "" , isEn: sessionStorage.getItem("isEn") } }
            ).then((response) => {
                var res = response.data
                if (res.code == 200) {
                    this.custormAnchor_content = res.data
                }
            }).catch(res => {

            })
        },
        sortByKey(array, key) {
            if (array) {
                return array.sort(function (a, b) {
                    var x = a[key];
                    var y = b[key];
                    return ((x < y) ? -1 : ((x > y) ? 1 : 0))
                })
            }

        }
    },
    watch: {

    },
    computed: {
        soft_custormAnchor_content: function () {
            return this.sortByKey(this.custormAnchor_content, 'softType')
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ServicePlatform-page {
    /* margin-top: 60px; */
    overflow: auto;
}

.first-page {
    /* min-height: 639px; */
    /* background: url("../assets/img/fuwupt_banner.png") no-repeat;
    background-size: 100%; */
    position: relative;
    height: calc(100% - 60px);
}

.first-page-title {
    color: #fff;
    text-align: center;
    position: absolute;
    top: 36%;
    left: 15%;
    margin-top: 4px;
    font-size: 48px;
    text-align: left;
    font-weight: 600;
}

.first-page-title>div:nth-child(2) {
    width: 68px;
    height: 3px;
    background: #fff;
    border-radius: 1px;
    margin-top: 10px;
    margin-bottom: 20px;
}

.first-page-title>div:nth-child(3) {
    font-size: 22px;
    font-weight: normal;
}

.first-page-titledesc {
    font-size: 22px;
    color: #fff;
    font-weight: normal;
}

@keyframes douBottom {
    0% {
        transform: translate(0px, 0px);
    }

    25% {
        transform: translate(0px, 5px);
    }

    50% {
        transform: translate(0px, 0px);
    }

    75% {
        transform: translate(0px, 5px);
    }

    100% {
        transform: translate(0px, 0px);
    }
}

.more-btn {
    display: inline-block;
    border: 1px solid #fff;
    width: 160px;
    margin-top: 20px;
    height: 44px;
    cursor: pointer;
    position: relative;
}

.btn-bgm {
    position: absolute;
    left: 0;
    top: 0;
    width: 0;
    height: 100%;
    background: #fff;
    z-index: 1;
}

.btn-text {
    color: rgb(255, 255, 255);
    z-index: 2;
    width: 100%;
    height: 100%;
    line-height: 38px;
    text-align: center;
    position: absolute;
    left: 0;
    top: 0;
    font-size: 1rem;
    font-weight: 400;
}

.home-main-product-text {
    color: #fff;
    position: absolute;
    bottom: 130px;
    right: 15%;
    font-size: 12px;
}


/* 菜单 */

.about-menu {
    height: 60px;
    line-height: 60px;
    padding-left: 50px;
    border-bottom: 1px solid #E3E3E3;
}

.about-menu>div {
    display: inline-block;
    margin-right: 50px;

}

.about-menu>div>span {
    cursor: pointer;
    padding: 0px;
    height: 100%;
    display: inline-block;
    color: #868686;
}


/* 选项内容 */
.about-content {
    /* min-height: 800px; */
    margin: 55px 0 100px;
}

.about-content>div {
    margin: 0 auto;
    /* margin-bottom: 100px; */
    /* padding-top: 55px; */
}

.about-content-img-left {
    padding: 0 40px 0 0;
}

.about-content-img-right {
    padding: 0 0 0 40px;
}

.about-content .about-content-img img {
    width: 100%;
}

.about-content .about-content-text {
    padding-top: 130px;
}

.about-content-text-left {
    padding-left: 30px;
    padding-right: 70px;
}

.about-content-text-right {
    padding-left: 100px;
}

.about-content .about-content-text .about-content-title {
    font-size: 32px;
    color: #2C2C2C;
    font-weight: 600;
}

.about-content .about-content-text .about-content-describe {
    margin-top: 15px;
    font-size: 22px;
    color: #2C2C2C;
}

.about-content .about-content-text .about-content-line {
    background: #3BBDE7;
    color: #3BBDE7;
    border-color: #3BBDE7;
    margin-top: 15px;
    width: 50px;
    height: 3px;
}


#miao3 {
    margin-bottom: 50px;
}


@media only screen and (max-width:1600px) {
    .about-content .about-content-text {
        padding-top: 40px;
    }

    .about-content .about-content-text .about-content-describe {
        font-size: 20px;
    }
}

@media only screen and (max-width:1300px) {
    .about-content .about-content-text {
        padding-top: 70px;
    }

    .about-content .about-content-text .about-content-describe {
        font-size: 18px;
    }
}

/* 笔记本适应性 */
@media only screen and (max-width:1200px) {
    .first-page-title>div:nth-child(2) {
        left: 5%;
    }

}

/* 中屏以上  宽度修正 */
@media only screen and (max-width:1200px) {
    .first-page-title>div:nth-child(2) {
        left: 15%;
    }

}

/*  小屏适应性配置  */
@media only screen and (max-width:991px) {
    .servicsplat-tabpart {
        width: 100%;
        height: 50px;
        line-height: 48px;
        color: #868686;
        border-bottom: 0.5px solid #E2E2E2;
    }

    .servicsplat-tab {
        float: left;
        margin: 0 15px;
        font-size: 14px;
    }

    .servicsplat-tab:first-child {
        margin-left: 20px;
    }

    /* .servicsplat-tab:last-child{
        padding-right: 0px;
    } */
    .servicsplat-tabActive {
        border-bottom: 2px solid#3BBDE7;
        color: #2C2C2C
    }

    .servicsplat-listMain {
        width: 100%;
        padding-top: 40px;
    }

    .servicsplat-list {
        margin-bottom: 36px;
    }

    .servicsplat-list-title {
        font-size: 18px;
        font-weight: 600;
        color: #202020;
        margin-bottom: 10px;
    }

    .servicsplat-list-desc {
        color: #2C2C2C;
        font-size: 14px;
        margin-bottom: 10px;
    }

    .servicsplat-list-img {
        text-align: center;
    }

    .servicsplat-list-img img {
        width: 80%;
    }
}

.header-video {
    height: -webkit-fill-available;
    width: -webkit-fill-available;
    object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/views/ServicePlatform.vue